import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { TabComponent } from "../../../shared/components/tabs/tab.component";
import { TabsComponent } from "../../../shared/components/tabs/tabs.component";
import { NgFor, NgIf } from "@angular/common";
import { buildProductDescriptionSections } from "../../common/build-product-description-sections";

@Component({
    selector: 'kb-tabbed-description',
    templateUrl: './tabbed-description.component.html',
    styleUrls: ['./tabbed-description.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    // This is needed currently to avoid the problem of duplicated descriptions
    // being rendered on SSR-rendered pages using this component.
    host: { ngSkipHydration: 'true' },
    standalone: true,
    imports: [NgIf, TabsComponent, NgFor, TabComponent],
})
export class TabbedDescriptionComponent implements OnChanges {
    sections: Array<{ title: string; content: string; extendedContent?: string }> = [];
    expand = false;

    @Input() keyFeatures?: string;
    @Input() description: string;
    @Input() alwaysCreateDescriptionTab = true;
    @Input() descriptionCutoffLength = 1000;

    ngOnChanges(changes: SimpleChanges) {
        this.sections = buildProductDescriptionSections({
            text: this.description,
            keyFeatures: this.keyFeatures,
            descriptionCutoffLength: this.descriptionCutoffLength,
        });
    }
}
